import { Box, Stack, styled, Tooltip } from '@mui/material';
import {
  ExtendedTypography,
  type ExtendedClientGridColumnHeaderProps,
} from '@issuemanager/apps/client/components';
import { useAtlasTheme } from '@issuemanager/apps/client/theme';
import { GridSortableHeader } from './grid-sortable-header';

const StyledStack = styled(Stack)`
  cursor: pointer;
`;

export function ClientGridHeader(params: ExtendedClientGridColumnHeaderProps) {
  const { colDef, sortModel, onSortModelChange } = params;
  const { headerName, renderHeaderFilter } = colDef;
  const theme = useAtlasTheme();

  const handleClick = () => {
    if (!colDef.sortable) return;

    const existingSortModel = [...(sortModel ?? [])];
    const existingSort = existingSortModel.find(
      (sort) => sort.field === params.field,
    );
    if (existingSort) {
      if (existingSort.sort === 'asc') {
        existingSort.sort = 'desc';
      } else {
        onSortModelChange?.(
          existingSortModel.filter((sort) => sort.field !== params.field),
        );
        return;
      }
    } else {
      existingSortModel.push({ field: params.field, sort: 'asc' });
    }
    onSortModelChange?.(existingSortModel);
  };

  const sortData = sortModel?.find((sort) => sort.field === params.field);
  const isAscending = sortData?.sort === 'asc';
  const isDescending = sortData?.sort === 'desc';

  return (
    <StyledStack
      spacing={1.5}
      onClick={handleClick}
      height={1}
      width={1}
      padding={1.5}
    >
      <Stack direction='row' spacing={1}>
        <Tooltip
          {...theme.presets.TooltipPresets.type.dark}
          title={
            <ExtendedTypography variant='textSm'>
              {headerName}
            </ExtendedTypography>
          }
        >
          <Box
            overflow='hidden'
            textOverflow='ellipsis'
            width={colDef.computedWidth}
          >
            <ExtendedTypography variant='textSm' fontWeight={600} noWrap>
              {headerName}
            </ExtendedTypography>
          </Box>
        </Tooltip>

        {colDef.sortable ? (
          <GridSortableHeader
            isAscending={isAscending}
            isDescending={isDescending}
          />
        ) : null}
      </Stack>

      <Box onClick={(e) => e.stopPropagation()}>
        {renderHeaderFilter?.(params)}
      </Box>
    </StyledStack>
  );
}
